import React from 'react';
import PropTypes from 'prop-types';
import {
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    withStyles,
} from '@material-ui/core';

/**
 * DropdownSelector - A simple dropdown component for key-value options.
 *
 * Props:
 * - options: Array<{ key: string|number, value: string|number }>
 * - onChange: function(event, selectedKey)
 * - value: string|number (selected key)
 * - includeAll: boolean (if true, show an 'All' option)
 * - allLabel: string (label for the 'All' option, default 'All')
 * - label: string (optional label for the dropdown)
 */
const StyledSelect = withStyles({
    root: {},
    select: {
        '&:focus': {
            backgroundColor: 'inherit',
        },
    },
})(Select);

const DropdownSelector = ({
    options,
    onChange,
    value,
    includeAll = false,
    allLabel = 'All',
    label,
    ...props
}) => {
    const handleChange = (event) => {
        if (onChange) {
            onChange(event, event.target.value);
        }
    };

    return (
        <FormControl variant="filled" fullWidth>
            {label && <InputLabel>{label}</InputLabel>}
            <StyledSelect value={value} onChange={handleChange} {...props}>
                {includeAll && <MenuItem value="all">{allLabel}</MenuItem>}
                {options.map((opt) => (
                    <MenuItem key={opt.key} value={opt.key}>
                        {opt.value}
                    </MenuItem>
                ))}
            </StyledSelect>
        </FormControl>
    );
};

DropdownSelector.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
        }),
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    includeAll: PropTypes.bool,
    allLabel: PropTypes.string,
    label: PropTypes.string,
};

export default DropdownSelector;
